<template>
  <div>
    <div v-if="loading">
      <LoadingState />
    </div>

    <div v-else>
      <div
        class="bg-gradient-to-tr from-blue-600 via-sky-600 to-indigo-500 h-64 pt-[56px] w-full flex items-center dark:bg-gradient-to-tr dark:from-gray-900 dark:via-slate-800 dark:to-gray-900"
      >
        <div class="container mx-auto px-5">
          <div
            class="2xl:border-l-4 xl:border-l-4 lg:border-l-4 md:border-l-4 border-white dark:border-lime-600 2xl:text-start xl:text-start md:text-start text-center"
          >
            <h1 class="font-bold text-3xl md:text-4xl text-white mb-2 indent-2 dark:text-lime-500">
              {{ $t("table.List-of-companies") }}
            </h1>
          </div>

          <button
            type="button"
            @click="$router.back()"
            class="text-white dark:text-lime-500 2xl:hidden xl:hidden lg:hidden md:hidden inline-flex items-center font-medium hover:text-gray-900 dark:hover:text-white cursor-pointer justify-center w-full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4 mr-2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
              />
            </svg>
            <span>{{ $t("table.go-back") }}</span>
          </button>

          <nav aria-label="Breadcrumb" class="2xl:block xl:block lg:block md:block hidden">
            <ol class="flex space-x-1 md:space-x-3 text-white dark:text-lime-500">
              <li class="flex items-center hover:text-gray-900 dark:hover:text-white cursor-pointer">
                <button
                  type="button"
                  @click="$router.push('/')"
                  class="inline-flex items-center font-medium"
                >
                  <svg
                    class="w-4 h-4 mr-2"
                    fill="white"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                    />
                  </svg>
                  <span class="hidden sm:block">{{ $t("ceo-message.main-screen") }}</span>
                </button>
              </li>

              <li aria-current="page">
                <div class="flex items-center">
                  <svg
                    class="w-6 h-6 text-gray-400"
                    fill="white"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span class="ml-1 font-medium md:ml-2 select-none">
                    {{ $t("table.List-of-companies") }}
                  </span>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <main class="container mx-auto px-5 my-8">
        <section
          class="rounded-2xl border border-gray-200 dark:border-lime-600 bg-white dark:bg-gray-900 shadow-lg overflow-hidden"
        >
          <div
            class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between border-b border-gray-200 dark:border-gray-700 bg-slate-50 dark:bg-gray-800 px-4 md:px-6 py-4"
          >
           
          </div>

          <div v-if="contracts.length === 0" class="p-8 text-center text-gray-500 dark:text-gray-300">
            {{ $t("table.doesnt-exist") }}
          </div>

          <div v-else class="hidden md:block overflow-x-auto">
            <table class="min-w-[1100px] w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead class="bg-blue-50 dark:bg-gray-800">
                <tr>
                  <th class="w-12 px-4 py-3 text-center text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider"></th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('inn')">
                      {{ $t("table.inn") }}
                      <span>{{ getSortIcon("inn") }}</span>
                    </button>
                  </th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('name')">
                      {{ $t("table.name") }}
                      <span>{{ getSortIcon("name") }}</span>
                    </button>
                  </th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('type')">
                      {{ $t("table.type") }}
                      <span>{{ getSortIcon("type") }}</span>
                    </button>
                  </th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('status')">
                      {{ $t("table.status") }}
                      <span>{{ getSortIcon("status") }}</span>
                    </button>
                  </th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('date')">
                      {{ $t("table.date") }}
                      <span>{{ getSortIcon("date") }}</span>
                    </button>
                  </th>
                  <th class="px-4 py-3 text-left text-xs font-bold text-blue-600 dark:text-lime-400 uppercase tracking-wider">
                    <button type="button" class="inline-flex items-center gap-1 uppercase" @click="sortBy('number')">
                      {{ $t("table.number") }}
                      <span>{{ getSortIcon("number") }}</span>
                    </button>
                  </th>
                </tr>
              </thead>

              <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                <template v-for="row in paginatedContracts" :key="row.key">
                  <tr
                    class="cursor-pointer bg-white dark:bg-gray-900 hover:bg-blue-50 dark:hover:bg-gray-800 transition"
                    :class="{ 'bg-blue-50 dark:bg-gray-800': isExpanded(row.key) }"
                    @click="toggle(row.key)"
                  >
                    <td class="px-4 py-3 text-center">
                      <span
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-blue-100 dark:border-lime-600 text-blue-600 dark:text-lime-400 bg-white dark:bg-gray-900"
                      >
                        <svg
                          class="h-5 w-5 transition-transform"
                          :class="{ 'rotate-90': isExpanded(row.key) }"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="m9 5 7 7-7 7"
                          />
                        </svg>
                      </span>
                    </td>
                    <td class="px-4 py-3 text-sm font-medium text-gray-800 dark:text-lime-500">
                      {{ row.item.inn }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 min-w-[260px]">
                      {{ row.item.name }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100">
                      {{ row.item.type }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100">
                      {{ row.item.status }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                      {{ row.item.date }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                      {{ row.item.number }}
                    </td>
                  </tr>

                  <tr v-show="isExpanded(row.key)" class="bg-slate-50 dark:bg-gray-950">
                    <td colspan="7" class="px-4 py-4">
                      <div class="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
                        <table class="min-w-[900px] w-full divide-y divide-gray-200 dark:divide-gray-700">
                          <thead class="bg-gray-100 dark:bg-gray-800">
                            <tr>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.payment") }}
                              </th>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.security") }}
                              </th>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.in-amount") }}
                              </th>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.jur-amount") }}
                              </th>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.state-number") }}
                              </th>
                              <th class="px-4 py-3 text-left text-xs font-bold text-blue-500 dark:text-lime-400 uppercase tracking-wider">
                                {{ $t("table.datee") }}
                              </th>
                            </tr>
                          </thead>

                          <tbody
                            v-if="row.item.applicationDTOs && row.item.applicationDTOs.length"
                            class="divide-y divide-gray-100 dark:divide-gray-700"
                          >
                            <tr
                              v-for="(app, appIndex) in row.item.applicationDTOs"
                              :key="`${row.key}-${appIndex}`"
                              class="hover:bg-gray-50 dark:hover:bg-gray-800"
                            >
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100">
                                {{ app.typeOfPayment }}
                              </td>
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100">
                                {{ app.typeOfSecurity }}
                              </td>
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                                {{ app.indAmount }}
                              </td>
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                                {{ app.jurAmount }}
                              </td>
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                                {{ app.stateNumber }}
                              </td>
                              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-100 whitespace-nowrap">
                                {{ app.date }}
                              </td>
                            </tr>
                          </tbody>

                          <tbody v-else>
                            <tr>
                              <td colspan="6" class="px-6 py-5 text-center text-sm text-gray-500 dark:text-lime-500">
                                {{ $t("table.doesnt-exist") }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div  class="md:hidden divide-y divide-gray-100 dark:divide-gray-700 bg-slate-50 dark:bg-gray-950">
            <article
              v-for="row in paginatedContracts"
              :key="row.key"
              class="p-4"
            >
              <button
                type="button"
                class="w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 text-left shadow-sm"
                @click="toggle(row.key)"
              >
                <div class="flex items-start justify-between gap-3">
                  <div class="min-w-0">
                    <p class="text-xs font-semibold uppercase tracking-wider text-blue-600 dark:text-lime-400">
                      {{ row.item.inn }}
                    </p>
                    <h3 class="mt-1 text-base font-bold leading-snug text-gray-900 dark:text-white">
                      {{ row.item.name }}
                    </h3>
                  </div>

                  <span
                    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-blue-100 dark:border-lime-600 text-blue-600 dark:text-lime-400"
                  >
                    <svg
                      class="h-5 w-5 transition-transform"
                      :class="{ 'rotate-90': isExpanded(row.key) }"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7" />
                    </svg>
                  </span>
                </div>

                <dl class="mt-4 grid grid-cols-1 gap-3 text-sm">
                  <div class="rounded-lg bg-slate-50 dark:bg-gray-800 p-3">
                    <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                      {{ $t("table.type") }}
                    </dt>
                    <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ row.item.type }}</dd>
                  </div>
                  <div class="rounded-lg bg-slate-50 dark:bg-gray-800 p-3">
                    <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                      {{ $t("table.status") }}
                    </dt>
                    <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ row.item.status }}</dd>
                  </div>
                  <div class="grid grid-cols-2 gap-3">
                    <div class="rounded-lg bg-slate-50 dark:bg-gray-800 p-3">
                      <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                        {{ $t("table.date") }}
                      </dt>
                      <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ row.item.date }}</dd>
                    </div>
                    <div class="rounded-lg bg-slate-50 dark:bg-gray-800 p-3">
                      <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                        {{ $t("table.number") }}
                      </dt>
                      <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ row.item.number }}</dd>
                    </div>
                  </div>
                </dl>
              </button>

              <div
                v-show="isExpanded(row.key)"
                class="mt-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4"
              >
                <div
                  v-if="row.item.applicationDTOs && row.item.applicationDTOs.length"
                  class="space-y-3"
                >
                  <div
                    v-for="(app, appIndex) in row.item.applicationDTOs"
                    :key="`${row.key}-mobile-${appIndex}`"
                    class="rounded-lg border border-gray-100 dark:border-gray-700 bg-slate-50 dark:bg-gray-800 p-3"
                  >
                    <dl class="grid grid-cols-1 gap-3 text-sm">
                      <div>
                        <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                          {{ $t("table.payment") }}
                        </dt>
                        <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.typeOfPayment }}</dd>
                      </div>
                      <div>
                        <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                          {{ $t("table.security") }}
                        </dt>
                        <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.typeOfSecurity }}</dd>
                      </div>
                      <div class="grid grid-cols-2 gap-3">
                        <div>
                          <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                            {{ $t("table.in-amount") }}
                          </dt>
                          <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.indAmount }}</dd>
                        </div>
                        <div>
                          <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                            {{ $t("table.jur-amount") }}
                          </dt>
                          <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.jurAmount }}</dd>
                        </div>
                      </div>
                      <div class="grid grid-cols-2 gap-3">
                        <div>
                          <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                            {{ $t("table.state-number") }}
                          </dt>
                          <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.stateNumber }}</dd>
                        </div>
                        <div>
                          <dt class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
                            {{ $t("table.datee") }}
                          </dt>
                          <dd class="mt-1 text-gray-800 dark:text-gray-100">{{ app.date }}</dd>
                        </div>
                      </div>
                    </dl>
                  </div>
                </div>

                <p v-else class="py-2 text-center text-sm text-gray-500 dark:text-lime-500">
                  {{ $t("table.doesnt-exist") }}
                </p>
              </div>
            </article>
          </div>

          <div
            v-if="contracts.length > 0"
            class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between border-t border-gray-200 dark:border-gray-700 px-4 md:px-6 py-4 bg-white dark:bg-gray-900"
          >
             <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
              <div class="flex items-center gap-2 md:hidden">
                <select
                  v-model="sortKey"
                  class="min-w-0 flex-1 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-lime-500"
                  @change="resetPagination"
                >
                  <option v-for="column in sortableColumns" :key="column.key" :value="column.key">
                    {{ column.label }}
                  </option>
                </select>

                <button
                  type="button"
                  @click="toggleSortDirection"
                  class="h-10 w-10 shrink-0 inline-flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-blue-600 dark:text-lime-400"
                  :title="sortDirection === 'asc' ? 'A-Z' : 'Z-A'"
                >
                  {{ sortDirectionIcon }}
                </button>
              </div>

              <label class="inline-flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300">
                <select
                  v-model.number="itemsPerPage"
                  class="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-lime-500"
                  @change="setItemsPerPage"
                >
                  <option v-for="option in itemsPerPageOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
              </label>
            </div>

            <div class="flex flex-wrap items-center gap-2">
              <button
                type="button"
                @click="previousPage"
                :disabled="currentPage === 1"
                class="h-9 w-9 inline-flex justify-center items-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-100 hover:text-blue-600 hover:border-blue-500 dark:hover:text-lime-400 dark:hover:border-lime-500 disabled:opacity-40 disabled:cursor-not-allowed transition"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 18l-6-6 6-6" />
                </svg>
              </button>

              <template v-for="(pageNumber, index) in pageNumbers" :key="`${pageNumber}-${index}`">
                <span
                  v-if="pageNumber === '...'"
                  class="h-9 min-w-9 inline-flex items-center justify-center px-2 text-gray-400"
                >
                  ...
                </span>
                <button
                  v-else
                  type="button"
                  @click="goToPage(pageNumber)"
                  class="h-9 min-w-9 inline-flex justify-center items-center rounded-lg border px-3 text-sm font-semibold transition"
                  :class="currentPage === pageNumber
                    ? 'border-blue-600 bg-blue-600 text-white dark:border-lime-600 dark:bg-lime-600'
                    : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-100 hover:text-blue-600 hover:border-blue-500 dark:hover:text-lime-400 dark:hover:border-lime-500'"
                >
                  {{ pageNumber }}
                </button>
              </template>

              <button
                type="button"
                @click="nextPage"
                :disabled="currentPage === totalPages"
                class="h-9 w-9 inline-flex justify-center items-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-100 hover:text-blue-600 hover:border-blue-500 dark:hover:text-lime-400 dark:hover:border-lime-500 disabled:opacity-40 disabled:cursor-not-allowed transition"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import LoadingState from "@/components/LoadingState";

export default {
  name: "MasterDetailFromApi",

  components: {
    LoadingState,
  },

  data() {
    return {
      contracts: [],
      expandedRows: [],
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 50],
      sortKey: "name",
      sortDirection: "asc",
      loading: true,
      hasError: false,
    };
  },

  computed: {
    sortableColumns() {
      return [
        { key: "inn", label: this.$t("table.inn") },
        { key: "name", label: this.$t("table.name") },
        { key: "type", label: this.$t("table.type") },
        { key: "status", label: this.$t("table.status") },
        { key: "date", label: this.$t("table.date") },
        { key: "number", label: this.$t("table.number") },
      ];
    },

    sortedContracts() {
      return [...this.contracts].sort((first, second) => {
        const firstValue = this.getSortValue(first, this.sortKey);
        const secondValue = this.getSortValue(second, this.sortKey);
        const direction = this.sortDirection === "asc" ? 1 : -1;

        if (firstValue < secondValue) {
          return -1 * direction;
        }

        if (firstValue > secondValue) {
          return 1 * direction;
        }

        return 0;
      });
    },

    paginatedContracts() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      return this.sortedContracts.slice(startIndex, endIndex).map((item, index) => ({
        item,
        key: this.getRowKey(item, startIndex + index),
      }));
    },

    totalPages() {
      return Math.max(Math.ceil(this.contracts.length / this.itemsPerPage), 1);
    },

    pageNumbers() {
      const pages = [];
      const total = this.totalPages;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }

        return pages;
      }

      pages.push(1);

      if (this.currentPage > 4) {
        pages.push("...");
      }

      const start = Math.max(2, this.currentPage - 1);
      const end = Math.min(total - 1, this.currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (this.currentPage < total - 3) {
        pages.push("...");
      }

      pages.push(total);

      return pages;
    },

    pageStart() {
      if (this.contracts.length === 0) {
        return 0;
      }

      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },

    pageEnd() {
      return Math.min(this.currentPage * this.itemsPerPage, this.contracts.length);
    },

    sortDirectionIcon() {
      return this.sortDirection === "asc" ? "↑" : "↓";
    },
  },

  mounted() {
    this.loadContracts();
  },

  methods: {
    loadContracts() {
      this.loading = true;

      fetch("https://web.uzcsd.uz/api/Application/GetContracts")
        .then((res) => res.json())
        .then((data) => {
          this.contracts = Array.isArray(data) ? data : [];
          this.currentPage = 1;
          this.expandedRows = [];
          this.hasError = false;
        })
        .catch(() => {
          this.hasError = true;
          this.contracts = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getRowKey(item, index) {
      return item.id || `${item.inn || "inn"}-${item.number || "number"}-${index}`;
    },

    getSortValue(item, key) {
      const value = item[key];

      if (value === null || value === undefined) {
        return "";
      }

      if (key === "date") {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? 0 : date.getTime();
      }

      if (key === "inn" || key === "number") {
        const number = Number(String(value).replace(/\D/g, ""));
        return Number.isNaN(number) ? 0 : number;
      }

      return String(value).toLocaleLowerCase();
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.toggleSortDirection();
        return;
      }

      this.sortKey = key;
      this.sortDirection = "asc";
      this.resetPagination();
    },

    toggleSortDirection() {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.resetPagination();
    },

    getSortIcon(key) {
      if (this.sortKey !== key) {
        return "↕";
      }

      return this.sortDirectionIcon;
    },

    toggle(key) {
      const index = this.expandedRows.indexOf(key);

      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(key);
      }
    },

    isExpanded(key) {
      return this.expandedRows.includes(key);
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.expandedRows = [];
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.expandedRows = [];
      }
    },

    goToPage(pageNumber) {
      if (pageNumber === this.currentPage) {
        return;
      }

      this.currentPage = pageNumber;
      this.expandedRows = [];
    },

    setItemsPerPage() {
      this.resetPagination();
    },

    resetPagination() {
      this.currentPage = 1;
      this.expandedRows = [];
    },
  },
};
</script>
